module.exports = __webpack_public_path__ + "static/media/bg.8e22a94f.jpg";